import { useDashboardFilters } from "@/features/dashboard/DashboardStateContext";
import { Box } from "@gettactic/components/src/primitives";
import { PagePost, PageSection } from "@gettactic/api";
import React from "react";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator
} from "@cmp-src/primitives/breadcrumb";

export const SiteInfoLayout = ({
  children,
  section,
  page,
  sectionPath
}: {
  children: React.ReactNode;
  section?: PageSection | null;
  page?: PagePost | null;
  sectionPath: PageSection[];
}) => {
  const { setSelectedSectionId, setSelectedPageId } = useDashboardFilters();

  const goToHome = (e: React.MouseEvent) => {
    e.preventDefault();
    setSelectedSectionId(undefined);
    setSelectedPageId(undefined);
  };

  const goToSection = (e: React.MouseEvent, sectionId: string) => {
    e.preventDefault();
    setSelectedSectionId(sectionId);
    setSelectedPageId(undefined);
  };

  return (
    <Box className="h-full w-full pt-1">
      {sectionPath.length > 0 && (
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href="#" onClick={goToHome}>
                Home
              </BreadcrumbLink>
            </BreadcrumbItem>
            {sectionPath.map((pathSection) => (
              <React.Fragment key={pathSection.id}>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  {pathSection.id === section?.id && !page ? (
                    <BreadcrumbPage>{pathSection.name}</BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink
                      href="#"
                      onClick={(e) => goToSection(e, pathSection.id)}
                      className="max-w-[150px] truncate"
                    >
                      {pathSection.name}
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
              </React.Fragment>
            ))}
            {page && section && (
              <>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="max-w-[150px] truncate">
                    {page.title}
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </>
            )}
          </BreadcrumbList>
        </Breadcrumb>
      )}
      {children}
    </Box>
  );
};
